import React, { useState, useEffect, useRef } from "react";
import { Box, useMediaQuery, IconButton, Drawer } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { Outlet } from "react-router-dom";

import AppBar from "./Components/AppBar";
import { darkTheme, lightTheme } from "../services/utils";
import localization from "../services/localization";
import { useThemeStore } from "../context/useThemeStore";
import { useLanguageStore } from "context/useLanguageStore";

import "../css/dashboard.css";

const MainLayout = ({ children }) => {
  const { currentLang, setCurrentLang } = useLanguageStore();

  const isTablet = useMediaQuery("(max-width: 1024px)");
  const [collapsed, setCollapsed] = useState(isTablet);
  const { theme } = useThemeStore();
  // const [theme, setTheme] = useState(
  //   localStorage.getItem("SA_user_theme") || "light",
  // );
  // const [darkMode, setDarkMode] = useState(
  //   localStorage.getItem("SA_user_theme") === "dark",
  // );
  const [historyList, setHistoryList] = useState([]);
  const [language, setLanguage] = useState(
    localStorage.getItem("SA_user_lang") || "En",
  );

  useEffect(() => {
    if (isTablet) {
      setCollapsed(true);
    } else {
      setCollapsed(false);
    }
  }, [isTablet]);

  // useEffect(() => {
  // document.documentElement.setAttribute("data-theme", theme);
  // setTheme(storedTheme);
  // setDarkMode(storedTheme === "dark");
  // }, []);

  const toggleSidebar = () => setCollapsed(!collapsed);

  // const handleDarkModeChange = (event) => {
  //   const checked = event.target.checked;
  //   setDarkMode(checked);

  //   if (checked) {
  //     document.documentElement.setAttribute("data-theme", "dark");
  //     localStorage.setItem("SA_user_theme", "dark");
  //     setTheme("dark");
  //   } else {
  //     document.documentElement.setAttribute("data-theme", "light");
  //     localStorage.setItem("SA_user_theme", "light");
  //     setTheme("light");
  //   }
  // };

  const loadHistory = (historyId) => {
    setSelectedHistory(historyId);
  };

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    localStorage.setItem("SA_user_lang", lang);
    localization.setLanguage(lang);
    setCurrentLang(lang);
    window.dispatchEvent(new Event("storage"));
  };

  return (
    <ThemeProvider theme={theme === "dark" ? darkTheme : lightTheme}>
      <div className="d-flex">
        {/* Main Content */}
        <div className="main-content flex-1 flex flex-col">
          {/* Top AppBar */}
          <AppBar
            collapsed={collapsed}
            handleLanguageChange={handleLanguageChange}
            language={language}
            // theme={theme}
            // handleDarkModeChange={handleDarkModeChange}
            // darkMode={darkMode}
            standAlone={true}
          />

          {/* Page Content */}
          <main
            className="flex-1 overflow-y-auto"
            style={{ paddingTop: "65px" }}
          >
            <Outlet />
          </main>
        </div>
      </div>
    </ThemeProvider>
  );
};

export default MainLayout;
